<template>
	<!-- header -->
	<header id="header">
		<div class="hInner header_aiorder header_aiorder_view subHeader">
			<div class="logoWrap">
				<div class="logo"><router-link to="#"></router-link></div>
				<div class="hLine"></div>
				<div class="hName">AI 의뢰서 상세 [접수번호 : {{ items.aiorder_no }}]</div>
			</div>
			<div class="hRight">
				<ul class="subBtn">
					<li v-if="items.aiorderAiorderDoc?.[0]">
						<button type="button" class="view_btn" id="aViewBtn"
							@click="commonjs.originalPopup(`/popup_aiorder_doc_print?file_path=${SERVER_URL}${items.aiorderAiorderDoc?.[0]?.file_path}/${items.aiorderAiorderDoc?.[0]?.name}`)">원본<span
								class="mnone">보기/출력</span></button>
					</li>
					<li><button type="button" class="print_btn" id="aPrintBtn" @click="confirm_print()"><span
								class="mnone">디지털의뢰서 </span>출력</button></li>
					<li v-if="(items.order_status === 'ords1' && globaljs.acc_type === 'hospital') ||
					((items.order_status === 'ords1' || items.order_status === 'ords2') && (globaljs.acc_type === 'lab'))">
						<button type="button" class="edit_btn" id="aEditBtn"
							@click="goto_url(`/aiorder_edit/${items.id}`)">수정</button>
					</li>
					<li v-if="items.order_status === 'ords1' && globaljs.acc_type === 'hospital'">
						<button type="button" class="save_btn" id="aSaveBtn" value="ords4"
							@click="handleStatusChange">
							주문 취소
						</button>
					</li>
					<li style="display:none;"><button type="button" class="download_btn" id="aDownloadBtn">다운<span
								class="mnone">로드</span></button></li>
				</ul>
				<div class="order_status select">
					<div class="aTit">제작상태</div>
					<select v-if="globaljs.acc_type === 'lab'" id="order_status_select" class="progress_status"
						:class="items.order_status"
						:value="items.order_status"
						:disabled="items.order_status === 'ords3' || items.order_status === 'ords4'"
						@change="handleStatusChange">
						<option value="ords1" :disabled="items.order_status !== 'ords2'" data-bg="#EEFFDD"
							data-color="#449f25" style="color: rgb(68, 159, 37)">의뢰서 접수</option>
						<option value="ords2" :disabled="items.order_status !== 'ords1'" data-bg="#E3FAF8"
							data-color="#1E8AD8" style="color: rgb(30, 138, 216)">의뢰서 확인</option>
						<option value="ords3" :disabled="items.order_status !== 'ords2'" data-bg="#f3f3f3"
							data-color="#666666" style="color: rgb(102, 102, 102)">출고 완료</option>
						<option value="ords4" :disabled="items.order_status === 'ords3'" data-bg="#ffffff"
							data-color="#e76150" style="color: rgb(231, 97, 80)">주문 취소</option>
					</select>
					<template v-else-if="globaljs.acc_type === 'hospital'">
						<div v-if="items.order_status === 'ords1'" class="progress_status"
							style="background-color:#EEFFDD; color:#449f25;">의뢰서 접수</div>
						<div v-if="items.order_status === 'ords2'" class="progress_status"
							style="background-color:#E3FAF8; color:#1E8AD8;">의뢰서 확인</div>
						<div v-if="items.order_status === 'ords3'" class="progress_status"
							style="background-color:#f3f3f3; color:#666666;">출고 완료</div>
						<div v-if="items.order_status === 'ords4'" class="progress_status"
							style="background-color:#ffffff; color:#e76150;">주문 취소</div>
					</template>
				</div>
			</div>
			<button type="button" class="popup_close" @click="commonjs.winClose()"></button>
		</div>
	</header>

	<section id="ai_order">
		<div class="content aiorder_view">
			<div class="contIn">
				<ul class="aiTab">
					<li class="aiTabBtn1 active">기공의뢰서</li>
					<li class="aiTabBtn2">대화내역</li>
					<li class="aiTabBtn3">수정이력</li>
				</ul>

				<!-- // 기공의뢰서 시작 -->
				<div class="aiLeft aiOrderdataWrap">
					<input type="hidden" name="mode" value="view">
					<input type="hidden" v-model="items.id">
					<input type="hidden" v-model="orderJsonData.prosthesis_cnt">
					<input type="hidden" v-model="items.remake_cnt">
					<input type="hidden" v-model="items.hospital_mb_id">
					<input type="hidden" v-model="items.lab_mb_id">

					<div class="ai_cont ai_cont2">
						<div class="boardTitWrap basicInfo">
							<div class="boardTit">기본 정보</div>
							<div v-if="items.order_status != 'ords3' && items.order_status != 'ords4'" class="ai_date">
								<div class="hopeDate">희망완료일
									<span>
										{{ orderJsonData.completeHopeDate }}
										<b class="d-day"
											:class="{ 'zero': commonjs.calculateDDay(orderJsonData.completeHopeDate) }">
											{{ (items.order_status === 'ords1' || items.order_status === 'ords2') && commonjs.isValidDate(orderJsonData.completeHopeDate) ? `(${commonjs.calculateDDay(orderJsonData.completeHopeDate)})` : '-' }}
										</b>
									</span>
								</div>
							</div>
							<div v-if="items.order_status === 'ords3'" class="cancelDate">출고 완료 <span>{{ commonjs.dateFormatYMDHis(items.order_complete_datetime) }}</span></div>
							<div v-if="items.order_status === 'ords4'" class="cancelDate">주문 취소 <span>{{ commonjs.dateFormatYMDHis(items.order_cancel_datetime) }}</span></div>
						</div>

						<table class="ai_order_table">
							<tbody>
								<tr>
									<th>환자명</th>
									<td>{{ orderJsonData.patientName }}</td>
									<th>나이 (성별)</th>
									<td>{{ orderJsonData.patientAge ? `${orderJsonData.patientAge}세` : '' }} {{ orderJsonData.patientGender ? `(${orderJsonData.patientGender}성)` : '' }}</td>
								</tr>
								<tr>
									<th>차트번호</th>
									<td>{{ orderJsonData.chartNum }}</td>
									<th>감염성질환</th>
									<td><span class="proStatus"
											:class="[{ yes: orderJsonData.infection === 'Y' }, { no: orderJsonData.infection === 'N' }]">{{ orderJsonData.infection ? orderJsonData.infection : '-' }}</span></td>
								</tr>
								<tr>
									<th>치과명</th>
									<td>{{ orderJsonData.hospitalName ? orderJsonData.hospitalName : (globaljs.acc_type === 'lab') ? others.mb_nick : globaljs.mb_nick }}</td>
									<th>담당자명</th>
									<td>{{ orderJsonData.hospitalName2 }}</td>
								</tr>
								<tr>
									<th>기공소명</th>
									<td>{{ orderJsonData.labName ? orderJsonData.labName : (globaljs.acc_type === 'lab') ? globaljs.mb_nick : others.mb_nick }}</td>
									<th>차트접수일</th>
									<td>{{ orderJsonData.chartDate }}</td>
								</tr>
								<tr>
									<th>주문일</th>
									<td>{{ orderJsonData.registerDate }}</td>
									<th>희망완료일</th>
									<td>
										{{ commonjs.dateFormatYMD(orderJsonData.completeHopeDate) }}
										<b v-if="items.order_status != 'ords3' && items.order_status != 'ords4'" class="d-day"
											:class="{ 'zero': commonjs.calculateDDay(orderJsonData.completeHopeDate) }">
											{{ (items.order_status === 'ords1' || items.order_status === 'ords2') && commonjs.isValidDate(orderJsonData.completeHopeDate) ? `(${commonjs.calculateDDay(orderJsonData.completeHopeDate)})` : '-' }}
										</b>
									</td>
								</tr>
							</tbody>
						</table>
					</div>

					<div class="ai_cont ai_cont3">
						<div class="boardTitWrap">
							<div class="boardTit">발송물품</div>
							<div class="form-group scan">
								<label class="form-label">구강스캔</label>
								<p class="form-control"><span class="proStatus"
										:class="orderJsonData?.scan === 'scan' ? 'yes' : 'no'">{{ orderJsonData?.scan === 'scan' ? 'Y' : 'N' }}</span></p>
							</div>
						</div>

						<div id="ai_prosthesis" class="ai_c3_form">
							<div v-if="prosthesis_sum < 1" class="form-group noPro_list">
								<p class="icon_notice_g"></p>
								<p>발송물품 없음</p>
							</div>
							<table v-else class="ai_order_table">
								<tr v-if="orderJsonData.prosthesis1 > 0">
									<th>상악Tray</th>
									<td>{{ orderJsonData.prosthesis1 }}<small>개</small></td>
								</tr>
								<tr v-if="orderJsonData.prosthesis2 > 0">
									<th>하악Tray</th>
									<td>{{ orderJsonData.prosthesis2 }}<small>개</small></td>
								</tr>
								<tr v-if="orderJsonData.prosthesis3 > 0">
									<th>Bite Tray</th>
									<td>{{ orderJsonData.prosthesis3 }}<small>개</small></td>
								</tr>
								<tr v-if="orderJsonData.prosthesis4 > 0">
									<th>Bite</th>
									<td>{{ orderJsonData.prosthesis4 }}<small>개</small></td>
								</tr>
								<tr v-if="orderJsonData.prosthesis5 > 0">
									<th>상악모델</th>
									<td>{{ orderJsonData.prosthesis5 }}<small>개</small></td>
								</tr>
								<tr v-if="orderJsonData.prosthesis6 > 0">
									<th>하악모델</th>
									<td>{{ orderJsonData.prosthesis6 }}<small>개</small></td>
								</tr>
								<tr v-if="orderJsonData.prosthesis7 > 0">
									<th>Analog</th>
									<td>{{ orderJsonData.prosthesis7 }}<small>개</small></td>
								</tr>
								<tr v-if="orderJsonData.prosthesis8 > 0">
									<th>코핑</th>
									<td>{{ orderJsonData.prosthesis8 }}<small>개</small></td>
								</tr>
								<tr v-if="orderJsonData.prosthesis9 > 0">
									<th>이전모델</th>
									<td>{{ orderJsonData.prosthesis9 }}<small>개</small></td>
								</tr>
								<tr v-if="orderJsonData.prosthesis10 > 0">
									<th>이전보철</th>
									<td>{{ orderJsonData.prosthesis10 }}<small>개</small></td>
								</tr>
							</table>
						</div>

						<div id="ai_prosthesis_detail" class="proView">
							<div class="boardTitWrap">
								<div class="boardTit">의뢰 내용</div>
							</div>
							<ul class="aiProCont_view">
								<aiorder_template_view :orderJsonData="orderJsonData" />
							</ul>

							<div v-if="(orderJsonData.prosthesis_cnt < 1 || orderJsonData.options_1 === '' || orderJsonData.teeth_1 === '')"
								class="form-row rowPro">
								<div class="form-group noPro_list">
									<p class="icon_notice_g"></p>
									<p>의뢰 내용 없음</p>
								</div>
							</div>
						</div>
					</div>

					<div class="aiL_cont aiL_cont4">
						<div class="boardTitWrap">
							<div class="boardTit">[선택] 첨부파일</div>
						</div>
						<div v-if="items.aiorderAiorderFile?.length < 1" class="form-row rowPro">
							<div class="form-group noPro_list">
								<p class="icon_notice_g"></p>
								<p>첨부파일 없음</p>
							</div>
						</div>
						<div v-else id="ai_file">
							<ul class="aiFileList" id="file">
								<li v-for="(file, index) in items.aiorderAiorderFile" :key="index">
									<div class="aiFileName">
										<span class="icon_file"></span>
										{{ file.file_origin_name ? file.file_origin_name : file.name }}
										<a class="fileDown" href="#" @click.prevent="commonjs.forceDownload(`${SERVER_URL}${file.file_path}/${file.name}`, `${file.name}`)">다운로드</a>
									</div>
								</li>
							</ul>
						</div>
					</div>

				</div><!-- // .aiLeft -->
				<!-- // 기공의뢰서 끝 -->

				<!-- // 수정이력 시작 -->
				<div class="aiLeft2 aiHistoryWrap hide">
					<div id="ai_edit_history">
						<div class="sub_tit">
							<p class="icon_notice"></p>
							<p><b>'상세'</b>클릭 시, <b>수정 이전의 데이터</b>를 확인할 수 있습니다.</p>
						</div>
						<div class="tableWrap">
							<table>
								<thead>
									<tr>
										<th>번호</th>
										<th>등록자</th>
										<th>수정 항목</th>
										<th>등록일자</th>
										<th>상세</th>
									</tr>
								</thead>
								<tbody :class="HZwrapper">
									<tr v-if="paginatedItems.length > 0" v-for="(history, index) in paginatedItems"
										:key="index" :class="HZlines">
										<!-- //240530 jamong 페이징 숫자 처리 -->
										<td>{{ history.idx }}</td>
										<td>
											{{ history?.memberAiorderHistory_Lab?.mb_nick || '' + history?.memberAiorderHistory_Hospital?.mb_nick || '' }}
											<br>
											({{ history?.lab_mb_id || history?.hospital_mb_id }})
										</td>
										<td
											v-if="history.basic_info || history.item_info || history.prosthesis_info || history.file_info">
											{{ history.basic_info ? history.basic_info.slice(0, history.basic_info.length - 1) : '' }}
											{{ history.item_info ? history.item_info.slice(0, history.item_info.length - 1) : '' }}
											{{ history.prosthesis_info ? history.prosthesis_info : '' }}
											{{ history.file_info ? history.file_info : '' }}
										</td>
										<td v-else>
											-
										</td>
										<td>{{ commonjs.dateFormatYMDHis(history.createdAt) }}</td>
										<td>
											<div class="detailBtn" @click="commonjs.aiorderHistoryPopup(`/aiorder_history/${items.id}/${history.id}`)">상세</div>
										</td>
									</tr>
									<tr v-else>
										<td colspan="5">데이터가 없습니다.</td>
									</tr>
								</tbody>
							</table>
						</div>

						<div class="page">
							<ul :id="HZpaginationId" class="pagination">
								<li :class="HZpaginationArrowsClass" v-show="currentPage > 1" @click="previousPage">&lt;</li>
								<li>
									<ul class="num_wrap">
										<li v-for="page in pagesToShow" :key="page"
											:class="['paginacaoValor', HZpaginationCustomClass, { 'active': currentPage === page }, 'num']"
											@click="goToPage(page)">
											{{ page }}
										</li>
									</ul>
								</li>
								<li :class="HZpaginationArrowsClass" v-show="currentPage < totalPages" @click="nextPage">&gt;</li>
							</ul>
						</div>
					</div>
				</div><!-- // .aiLeft2 -->
				<!-- // 수정이력 끝 -->

				<div class="aiRight">
					<!-- // 알림톡 시작 -->
					<div class="aiR_cont aiTalkWrap">
						<form ref="form_talk_send" id="form_talk_send" class="aiTalk"
							:action="`${SERVER_URL}/api/app/talk`"
							@submit.prevent="talkjs.talkSend($event, globaljs.mb_id, globaljs.mb_boss_id, other_id, talk_content, items.id)"
							method="post" autocomplete="off">
							<ul class="talk_profile aiR_top">
								<li class="profileImg">
									<img v-if="others.mb_icon" :src="`${SERVER_URL}/images/member/${others.mb_icon}`"
										style="max-width:100%;">
									<img v-else src="/img/common/profile_ex.png" style="max-width:100%;">
								</li>
								<li class="profileName">{{ others.mb_nick }}</li>
							</ul>

							<div class="aiTalkWrap">
								<div class="talk_inner">
									<div v-for="(talk, index) in items.aiorderTalk" :key="index"
										:class="talkClass(talk)">
										<div :class="{ 'message_box': talk.notice != 'Y' }">
											<span
												v-html="commonjs.replaceToBr(commonjs.stripTags(talk.content))"></span>
											<div class="time">{{ commonjs.dateFormatYMDHis(talk.createdAt) }}</div>
										</div>
									</div>
								</div>
								<div class="talk_input_box">
									<textarea v-model="talk_content" id="content" class="talk_content" @keyup.enter.prevent="talkjs.talkSend($event, globaljs.mb_id, globaljs.mb_boss_id, other_id, talk_content, items.id)"></textarea>
									<div class="talk_input_btn">
										<button type="button" class="send_btn"
											@click="talkjs.talkSend($event, globaljs.mb_id, globaljs.mb_boss_id, other_id, talk_content, items.id)">전송</button>
									</div>
								</div>
							</div>
						</form>
					</div>
					<!-- // 알림톡 끝 -->

					<div v-if="globaljs.acc_type === 'lab'" id="lab_memo_wrap" class="aiR_cont2 aiLabmemoWrap">
						<form ref="form_labmemo_update" id="form_labmemo_update"
							:action="`${SERVER_URL}/api/app/aiorder/memo`" @submit.prevent="labmemo_update_submit()"
							method="post" autocomplete="off">
							<div class="boardTitWrap">
								<button type="button" class="boardTit">MEMO<div class="memoSave" id="lab_memo_save"
										@click="labmemo_update_submit()">저장</div></button>
							</div>
							<div id="ai_memo">
								<textarea v-model="items.lab_memo" id="lab_memo"
									placeholder="기공소 내에서만 확인되는 내용입니다." @keyup.enter.prevent="labmemo_update_submit()"></textarea>
							</div>
						</form>
					</div>
				</div><!-- // .aiRight -->

			</div>
		</div>
	</section>

</template>

<script setup>
import { env as SERVER_URL } from '@/components/utils/env';
import { onMounted, ref, computed, watch, onBeforeUnmount } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import * as globaljs from '@/components/utils/global';
import * as commonjs from '@/components/utils/common';
import * as aiorderjs from '@/components/utils/aiorder';
import * as talkjs from '@/components/utils/talk';
import aiorder_template_view from '@/components/layout/aiorder_template_view';
import eventBus from '@/components/utils/eventBus';

const route = useRoute();
const router = useRouter();

const props = defineProps({
	id: {
		type: Number,
		required: true
	},
});

const today = moment().format('YYYY-MM-DD');
const now_time = moment().format('YYYY-MM-DD HH:mm:ss');

let submitingFlag = false; // 플래그 변수
const withSubmitFlag = async (asyncFunc) => {
	if (submitingFlag) return; // 요청 중복 방지
		submitingFlag = true; // 요청 시작 시 플래그 설정
	try {
		await asyncFunc(); // 비동기 함수 실행
	} finally {
		submitingFlag = false; // 요청이 끝나면 플래그 해제
	}
};

const aiorder_id = ref(props.id);

watch(
	() => props.id,
	(newVal) => {
		aiorder_id.value = newVal;
	}
);

const items = ref([]); // 보철물 (분류+상세+즐겨찾기)
const orderJsonData = ref([]); // order_json_data
const histories = ref([]); // order_json_data

const HZwrapper = 'paginationTable';
const HZlines = 'tableItem';
const HZperPage = 10;
const HZpaginationId = 'pagination-container';
const HZpaginationArrowsClass = 'paginacaoCursor';
const HZpaginationCustomClass = 'customPagination';
const currentPage = ref(1);
const totalPages = computed(() => Math.ceil(histories.value.length / HZperPage));

const paginatedItems = computed(() => {
	const start = (currentPage.value - 1) * HZperPage;
	const end = start + HZperPage;
	return histories.value.slice(start, end);
});

const goToPage = (page) => {
	if (page > 0 && page <= totalPages.value) {
		currentPage.value = page;
	}
};

const previousPage = () => {
	if (currentPage.value > 1) {
		currentPage.value--;
	}
};

const nextPage = () => {
	if (currentPage.value < totalPages.value) {
		currentPage.value++;
	}
};

const pagesToShow = computed(() => {
	const pages = [];
	const totalPagesValue = totalPages.value;
	const currentPageValue = currentPage.value;
	const showPagesCount = 10; // 한번에 보여줄 페이지 번호 개수
	const halfShowPagesCount = Math.floor(showPagesCount / 2);

	let start = Math.max(1, currentPageValue - halfShowPagesCount);
	let end = Math.min(totalPagesValue, currentPageValue + halfShowPagesCount);

	if (currentPageValue <= halfShowPagesCount) {
		end = Math.min(totalPagesValue, showPagesCount);
	}

	if (currentPageValue > totalPagesValue - halfShowPagesCount) {
		start = Math.max(1, totalPagesValue - showPagesCount + 1);
	}

	for (let i = start; i <= end; i++) {
		pages.push(i);
	}

	return pages;
});

const others = ref([]); // 선택한 상대편 정보
const other_id = ref();
watch(
	() => other_id.value,
	(newVal) => {
		getOther();
	}
);

const prosthesis_sum = ref(0);

const goto_url = (url) => {
	router.push(url);
}

const talk_content = ref();

const talkClass = (talk) => {
	let tc = "";
	if (talk.notice === 'Y') {
		tc = "talk_notice";
	} else {
		if (talk.send_mb_id === globaljs.mb_boss_id) {
			tc = "talk_me";
		} else if (talk.recv_mb_id === globaljs.mb_boss_id) {
			tc = "talk_you";
		}
	}
	return tc;
}

const confirm_print = async () => {
	if (parseInt(orderJsonData.value.prosthesis_cnt) < 1) {
		const print_confirm = await commonjs.confirmSwal('의뢰서 출력 확인', '입력된 의뢰 내용이 없습니다. \n출력 페이지로 이동하시겠습니까?', 'nl');
		if (!print_confirm) {
			return false;
		} else {
			commonjs.printPopup(`/aiorder_print/${items.value.id}`);
		}
	} else {
		commonjs.printPopup(`/aiorder_print/${items.value.id}`);
	}
}

// 상태 변경 처리
const handleStatusChange = async (event) => {
	try {
		const before = items.value.order_status;
		const after = event.target.value;
		const isSuccess = await aiorderjs.statusChange(event, items.value.id, items.value.aiorder_no, items.value.order_status, globaljs.acc_type);

		if (isSuccess) {
			if (after === 'ords3') {
				items.value.order_complete_datetime = now_time;
			} else if (after === 'ords4') {
				items.value.order_cancel_datetime = now_time;
			}
		} else {
			items.value.order_status = before;
		}
	} catch (error) {
		console.error('Error changing status:', error);
	}
};

const updateStatus = (stat) => {
	const target = document.querySelector('#order_status_select');
	commonjs.progress_status_color_chg(target); // 240731 select에 색상변경
	items.value.order_status = stat;
}

const updateTalkcontent = (content) => {
	talk_content.value = content;
}

onMounted(async () => {
	commonjs.DOMLoaded(); // 240724 헤더가 없는 페이지는 불러와야됨
	aiorderjs.DOMLoaded();
	talkjs.DOMLoaded();

	// 이벤트 리스너 설정
	eventBus.on('update-status', updateStatus);
	eventBus.on('update-talkcontent', updateTalkcontent);

	await getModels();
});

// 컴포넌트가 언마운트될 때 이벤트 리스너 해제
onBeforeUnmount(() => {
	eventBus.off('update-status', updateStatus);
	eventBus.off('update-talkcontent', updateTalkcontent);
});

const getOther = async () => {
	const params = new URLSearchParams();
	params.append('mb_boss_id', globaljs.mb_boss_id);
	params.append('other_id', other_id.value);
	params.append('acc_type', globaljs.acc_type);
	//params.append('mb_level', globaljs.mb_level);

	try {
		let response = await axios.get(`${SERVER_URL}/api/app/member/other`, { params });
console.debug(response.data.result);
		if (response.data.result?.[0]) {
			others.value = response.data.result[0];

		}
	} catch (error) {
console.error('Error getOther:', error);
	}
}

const getModels = async () => {
	if (isNaN(props.id)) {
		commonjs.formSwal('정보 없음', '주문서 정보를 가져오지 못했습니다. URL를 다시 한번 확인해 주세요.');
	} else {
		try {
			let response = await axios.get(`${SERVER_URL}/api/app/aiorder/${props.id}`);
	console.debug(response.data.result);
			items.value = response.data.result;
			//items.value.aiorderAiorderDoc[0]
			histories.value = items.value.aiorderAiorderHistory_Id;
	console.debug(histories.value);
			// 241022 파싱할때 특수문자 오류. sanitizeJSONString함수 추가.
			const sanitizedData = commonjs.sanitizeJSONString(items.value.order_json_data);
			orderJsonData.value = JSON.parse(sanitizedData);
	console.debug(orderJsonData.value);

			other_id.value = (globaljs.acc_type === 'lab') ? items.value.hospital_mb_id : items.value.lab_mb_id;
			//await getOther();

			for (let i = 1; i <= 10; i++) {
				if (typeof orderJsonData.value[`prosthesis${i}`] !== 'undefined') {
	console.debug(`prosthesis${i}`, parseInt(orderJsonData.value[`prosthesis${i}`]) );
					prosthesis_sum.value += isNaN(parseInt(orderJsonData.value[`prosthesis${i}`])) ? 0 : parseInt(orderJsonData.value[`prosthesis${i}`]);
				}
			}

		} catch (error) {
	console.error('Error getModels:', error);
		}
	}
}

async function labmemo_update_submit() {
	await withSubmitFlag(async () => {
		if (items.value.lab_memo === '' || items.value.lab_memo.replace(/[\s\n]/g, '') === '') {
			toast.fire({
				icon: "error",
				title: '내용이 없습니다.'
			});
			return false;
		}

		if (globaljs.mb_level != 4 && globaljs.mb_level != 5) {
			toast.fire({
				icon: "error",
				title: '메모는 기공소만 저장할 수 있습니다..'
			});
			return false;
		}

		const params = new URLSearchParams();
		params.append('mb_boss_id', globaljs.mb_boss_id);
		params.append('acc_type', globaljs.acc_type);
		//params.append('mb_level', globaljs.mb_level);
		params.append('aiorder_id', items.value.id);
		params.append('lab_memo', items.value.lab_memo);

		// URLSearchParams를 객체로 변환
		const object = {};
		params.forEach((value, key) => {
			if (key.endsWith('[]')) {
				const arrayKey = key.slice(0, -2);
				if (!object[arrayKey]) {
					object[arrayKey] = [];
				}
				object[arrayKey].push(value);
			} else {
				object[key] = value;
			}
		});

		// 결과 확인용 로그 출력
		const jsonString = JSON.stringify(object, null, 2); // 들여쓰기 2칸으로 JSON 문자열화
	console.info(jsonString);

		try {
			const response = await axios.put(`${SERVER_URL}/api/app/aiorder/memo`, params);
	console.debug(response.data.result);
			toast.fire({
				icon: "success",
				title: "메모를 저장했습니다."
			});
		} catch (error) {
			console.error(error?.response?.data);
			commonjs.formSwal(`필수 입력`, error?.response?.data?.errors[0]?.msg);
		}
	});
}
</script>